(() => {
  'use strict';
  const experience = document.querySelector('[data-r3-fuga-scroll-experience]');
  const video = experience && experience.querySelector('[data-r3-fuga-scroll-video]');
  if (!experience || !video) return;
  const sticky = experience.querySelector('.r3boa-scroll__sticky');
  const warranty = experience.querySelector('[data-r3-fuga-warranty]');
  const boaCopy = experience.querySelector('[data-r3-fuga-boa-copy]');
  let ready = false, raf = 0, start = 0, range = 1, last = -1, retries = 0, retryTimer = 0;
  const source = video.querySelector('source')?.getAttribute('src') || '';
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  function measure() {
    const rect = experience.getBoundingClientRect();
    start = window.scrollY + rect.top;
    range = Math.max(1, experience.offsetHeight - window.innerHeight);
    schedule();
  }
  function sync() {
    raf = 0;
    const progress = clamp((window.scrollY - start) / range, 0, 1);
    const inside = window.scrollY >= start && window.scrollY <= start + range;
    sticky.classList.toggle('is-active', inside);
    sticky.classList.toggle('is-ended', window.scrollY > start + range);
    const warrantyVisible = progress >= 0.15;
    const boaCopyVisible = progress >= 0.30;
    if (warranty) { warranty.classList.toggle('is-visible', warrantyVisible); warranty.setAttribute('aria-hidden', warrantyVisible ? 'false' : 'true'); }
    if (boaCopy) { boaCopy.classList.toggle('is-visible', boaCopyVisible); boaCopy.setAttribute('aria-hidden', boaCopyVisible ? 'false' : 'true'); }
    if (!ready) return;
    const duration = Number.isFinite(video.duration) ? video.duration : 8;
    const target = progress === 1 ? duration : progress * duration;
    if (Math.abs(target - last) < .002) return;
    last = target;
    video.pause();
    try { video.currentTime = target; } catch (_) {}
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(sync); }
  function frameReady() { if (video.readyState >= 2) video.classList.add('is-frame-ready'); }
  function armRetry() {
    clearTimeout(retryTimer);
    if (!video.classList.contains('is-frame-ready') && retries < 3) retryTimer = setTimeout(retryLoad, 5000);
  }
  function retryLoad() {
    if (video.readyState >= 2 || retries >= 3) return frameReady();
    retries += 1;
    video.src = source + (source.includes('?') ? '&' : '?') + 'r3retry=' + retries;
    try { video.load(); } catch (_) {}
    armRetry();
  }
  function metadata() { ready = Number.isFinite(video.duration) && video.duration > 0; video.pause(); measure(); armRetry(); }
  video.muted = true; video.defaultMuted = true; video.playsInline = true; video.autoplay = false; video.loop = false; video.controls = false; video.pause();
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', measure, {passive:true});
  window.addEventListener('orientationchange', measure, {passive:true});
  window.addEventListener('load', measure, {once:true});
  video.addEventListener('loadedmetadata', metadata, {once:true});
  video.addEventListener('durationchange', metadata);
  video.addEventListener('loadeddata', frameReady);
  video.addEventListener('seeked', frameReady);
  video.addEventListener('canplay', schedule);
  video.addEventListener('error', retryLoad);
  video.addEventListener('stalled', armRetry);
  video.addEventListener('play', () => video.pause());
  document.addEventListener('visibilitychange', () => { if (!document.hidden && video.readyState < 2) retryLoad(); });
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(experience);
  if (video.readyState >= 1) metadata(); else { video.load(); armRetry(); }
  measure();
})();
